import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

// 管理対象の状態
const state = {
  auth: { // 状態`Auth`
    token: localStorage.getItem('mptoken'), // locale storage から取得する
    userId: null, // nullで初期化
    tempPasswordAuthFlg: null,
    groupLargeId: null,
    groupSmallId: null,
    companyId: null,
    branchId: null,
    groupAdminFlg: null,
    adminFlg: null
  },
  form: {
    adminAccountEntryList: {
      groupSmallId: null,
      keyword: '',
      name: '',
      mailAddress: '',
      selected: []
    },
    adminAccountList: {
      groupSmallId: null,
      keyword: '',
      name: '',
      mailAddress: '',
      selected: []
    },
    adminAccountServiceApplicationList: {
      serviceId: null,
      groupSmallId: null,
      keyword: '',
      name: '',
      mailAddress: '',
      selected: []
    },
    AdminSendMailSend: {
      fromAddressList: []
    }
  },
  isLoading: false,
  codeDefList: [],
  prefCodeList: [],
  teamJCodeList: [],
  teamWECodeList: [],
  isLangJa: true,
  manualUrl: ''
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
})
